import { useCallback, useContext, useState } from "react";
import { AppSettingsVar } from "../../_project/settings";
import { getCookie, csrfSafeMethod } from "./functions/getCookie";
import { resolveRestUrl } from "./functions/resolveRestUrl";
import UserContext from "../../store/UserContext";
import i18n from "../../i18n";


var csrftoken = getCookie('csrftoken');

export const addAuthorization = async (requestObject) => {
    var body = JSON.stringify({'username':AppSettingsVar.user, 'password':AppSettingsVar.password})
    const url_prefix = Object.keys(AppSettingsVar).includes('portal_prefix') ? AppSettingsVar.portal_prefix : ''
    var token_response = await fetch( 
        AppSettingsVar.base_url + url_prefix + 'api-token-auth/' 
        , { 'method':'POST',
            'body':body, 
            'data':body, 
            'headers':{
                'Accept':'application/json',  
                'Content-Type':'application/json',  
                "X-Requested-With":'XMLHttpRequest',
                "X-CSRFToken":csrftoken
            }
        }
    )
    var token = await token_response.json()
    requestObject['headers']['Authorization'] = 'Token ' +  token.token
    return requestObject
}

const useForm = (applyData) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const userContext = useContext(UserContext)

    const sendRequest = useCallback(async (requestConfig, reset=true, additionalArgs = {}) => {
        setIsLoading(true);
        setError(null);
        try{
            var requestObject = {
                 method: requestConfig.method ? requestConfig.method : 'GET'
                ,headers: requestConfig.headers ? { ...requestConfig.headers } : {}
                ,body: null
            }
            if (!csrfSafeMethod(requestConfig.method)) {
                requestObject['headers']["X-CSRFToken"] = csrftoken;
                requestObject['headers']["X-Requested-With"] = 'XMLHttpRequest';
            }

            var dataPayload = requestConfig.data
            if (requestConfig.reload && dataPayload) {
                if (dataPayload instanceof FormData) {
                    dataPayload.append('__reload', true)
                } else if (typeof dataPayload === 'object' && dataPayload !== null && !Array.isArray(dataPayload)) {
                    dataPayload = { ...dataPayload, __reload: true }
                }
            }

            if (dataPayload != null && dataPayload !== undefined) {
                if (dataPayload instanceof FormData) {
                    requestObject.body = dataPayload
                    delete requestObject.headers['Content-Type']
                } else if (typeof dataPayload === 'string') {
                    requestObject.body = dataPayload
                    if (!requestObject.headers['Content-Type']) {
                        requestObject.headers['Content-Type'] = 'application/json'
                    }
                } else {
                    requestObject.body = JSON.stringify(dataPayload)
                    requestObject.headers['Content-Type'] = 'application/json'
                }
            }

            var url = requestConfig.url
            if(!url) return
            url = resolveRestUrl(url)
            if (requestConfig.autoSaved && !url.includes('_auto_save=')) {
                url += (url.includes('?') ? '&' : '?') + '_auto_save=true'
            }
            if(AppSettingsVar.debug){
                if(url.replace(AppSettingsVar.base_url, "").startsWith("/rest/")){
                    requestObject = await addAuthorization(requestObject)
                }
            }
            const response = await fetch(url, { ...requestObject })
            const urlParams = new URLSearchParams(url.split('?')[1]) ;
            var addAnother; 
            if(dataPayload && dataPayload instanceof FormData) {
                addAnother = dataPayload.has('__addAnother__') 
            }
            else if(dataPayload && typeof dataPayload === 'object')
                addAnother = dataPayload.__addAnother__
            else{
                addAnother = false
            }
            var validated_form = {
                valid : response.status === 200,
                status : response.status,
                addAnother : addAnother,
                returnUrl : urlParams.has('return'),
                redirect_url : response.redirect_url,
                autoSaved : requestConfig.autoSaved || false,
                form : null,
                save_status_code:response.save_status_code,
                save_status:response.save_status,
            }
            if(requestConfig.hasOwnProperty('formIndex')){
                validated_form.formIndex = requestConfig.formIndex
            }
            if(response.status === 422 || requestConfig.reload){
                const response_data = await response.json()
                validated_form = {...validated_form, ...response_data}
                if(requestConfig.hasOwnProperty('formIndex')){
                    validated_form.formIndex = requestConfig.formIndex
                }
                if(response_data.response_message && userContext && userContext.setMessages){
                    userContext.setMessages(response_data.response_message)
                }
                applyData(validated_form, reset, additionalArgs)
                return response_data
            }
            else if(response.status === 200){
                const response_data = await response.json()
                if(response_data.context_reload && userContext && userContext.setContextReload){
                    userContext.setContextReload(response_data.context_reload)
                }
                validated_form = {...validated_form, ...response_data}
                if(requestConfig.hasOwnProperty('formIndex')){
                    validated_form.formIndex = requestConfig.formIndex
                }
                if(requestConfig.method === 'POST' && window.opener && window.opener.finalizeTag){
                    window.opener.finalizeTag(response_data.pk, response_data.instance)
                    window.close()
                }
                if(response_data.response_message && userContext && userContext.setMessages){
                    userContext.setMessages(response_data.response_message)
                }
                applyData(validated_form, reset, additionalArgs)
                return response_data
            }
            else if (response.status === 404){
                var response_data = await response.json()
                throw new Error(i18n.t('We could not find the page you are looking for'));
            }
            else if(response.status === 500){
                try {
                    error = await response.json();
                    throw new Error(error.errors[0] + i18n.t(" - You're not allowed to do this"));
                } catch (e) {
                    throw new Error(i18n.t("Something went wrong on the server side."));
                }
            }
            else if(response.status === 403 || response.status===401){
                try {
                    let error = await response.json();
                    throw new Error(error.errors[0] + i18n.t(" - You're not allowed to do this"));
                } catch (e) {
                    throw new Error(i18n.t("You're not allowed to do this"));
                }
            }
            else{
                throw new Error(i18n.t("Something went wrong"));
            }

        }catch(err){
            setError(err.message || i18n.t('Something went wrong!'))
            throw err; // Re-throw the error so it can be caught by the caller
        }finally{
            setIsLoading(false)
        }
    }, [applyData])

    return {
         isLoading
        ,error
        ,sendRequest
    }
}

export default useForm